import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, message, Button } from "antd";
import { cookies } from "../../utils"
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 16,
    offset: 8,
  },
};
export class AccountModifyPwd extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSubmit = e => {
    e.preventDefault();
    let stuID = cookies.getCookie('UserKey');
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { OldPassword, confirm, password } = values;
        if (password !== confirm) {
          message.warn('请确认密码一致！');
          return;
        }
        if (OldPassword === password) {
          message.warn('新密码和原始密码不能相同');
          return;
        }
        const params = {
          StuID: stuID,
          oldPassword: OldPassword,
          newPassword: password,
        }
        this.props.actions.fetchEditStuPwd(params).then(res => {
          if (res.SuccessResponse) {
            message.success('密码修改成功，请重新登录');
            this.props.actions.fetchLogout();
            this.props.actions.fectchLoginOut();
            this.props.history.replace('/login');
            this.props.actions.clearCartCount();
          }
        })
      }
    })
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="center-account-modify-pwd">
        <h1>
          *&nbsp;温馨提示:&nbsp;为了您的账号安全，请及时修改初始密码，防止盗号
          (初始密码为身份证后六位/手机号后六位)；密码最好不要设置成生日、电话号码等.
        </h1>
        <Form onSubmit={this.handleSubmit.bind(this)}>
          <FormItem
            {...formItemLayout}
            label="原始密码"
          >
            {getFieldDecorator('OldPassword', {
              initialValue: '',
              rules: [
                {
                  required: true, message: "请输入原始密码"
                }
              ]
            })(
              <Input type="password" placeholder="请输入原始密码" style={{ width: 300, height: 40 }} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="新密码"
          >
            {getFieldDecorator('password', {
              initialValue: '',
              rules: [
                {
                  required: true, message: "请输入新密码"
                }, {
                  min: 6, message: "字符长度不小于六位",
                }, {
                  max: 23,
                  message: '字符长度不超过二十三位',
                }, {
                  validator: (rule, value, cb) => {
                    let lvl = 0;
                    if (/[0-9]/.test(value)) {
                      lvl++;
                    }
                    if (/[a-zA-Z]/.test(value)) {
                      lvl++;
                    }
                    if (/[^0-9a-zA-Z_]/.test(value)) {
                      lvl++;
                    }
                    if (lvl >= 2) {
                      cb();
                    } else {
                      cb('密码须包含数字、字母、符号至少2种或以上元素')
                    }
                  }
                }
              ]
            })(
              <Input type="password" placeholder="请输入新密码" style={{ width: 300, height: 40 }} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="确认密码"
          >
            {getFieldDecorator('confirm', {
              rules: [
                {
                  required: true, message: "请输入确认密码"
                },
                {
                  min: 6,
                  message: '字符长度不小于六位',
                }, {
                  max: 23,
                  message: '字符长度不超过二十三位',
                }],
              initialValue: ''
            })(
              <div>
                <Input type="password" placeholder="请确认密码" style={{ width: 300, height: 40 }} />
                <p className="tip">密码长度6-23位，须包含数字、字母、符号至少2种或以上元素</p>
              </div>
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="theme" htmlType="submit" className="submitBtn">确认修改</Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(AccountModifyPwd));



// WEBPACK FOOTER //
// ./src/features/center/AccountModifyPwd.js